<template>
  <div class="breadcrumb">
    <template v-for="(item, index) in breadCrumbList.breadCrumbList">
      <a v-if="index == 0" :key="index" @click="changRouter('main')">{{ item.menu_name }}&nbsp;<template
          v-if="breadCrumbList.breadCrumbList.length != 1">></template></a>
      <span v-else-if="index == breadCrumbList.breadCrumbList.length - 1" :key="index">&nbsp;
        <el-select v-model="item.menu_link" size="mini" style="width:130px;" @change="changRouter">
          <el-option v-for="array in breadCrumbList.selectArray" :key="array.menu_link?array.menu_link:array.menu_id"
            :label="array.menu_name" :value="array.menu_link">
          </el-option>
        </el-select>
        &nbsp;
      </span>
      <span v-else :key="index">&nbsp;{{ item.menu_name }}&nbsp;></span>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapState("navTabs", ["breadCrumbList"]),
  },
  methods: {
    changRouter(value) {
      this.$router.push({
        name: value
      });
    },
  }
}
</script>

<style scoped>
.breadcrumb {
  height: 100%;
  user-select: none;
  box-sizing: border-box;
  display: inline-flex;
  justify-content: left;
  align-items: center;
  font-size: 14px;
}
.breadcrumb a {
  color: #000;
}
.breadcrumb a:hover {
  color: #409eff !important;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: black;
}
</style>
